import { SxProps, Theme } from '@mui/material';
import { useEffect, useState } from 'react';
import { TextField } from 'src/components';
import Autocomplete from 'src/components/Autocomplete';
import HbsUcretTarifetanim from 'src/models/Settings/Generals/HbsUcretTarifeTanimDTO';
import HbsUcretTarifetanimService from 'src/services/Settings/Generals/HbsUcretTarifetanim.service';
import { helper } from 'src/utils/helper';
import SnackbarUtils from 'src/utils/SnackbarUtils';
import { AutoCompleteTargetNumber } from '../Types/autocomplete.target';

interface ITarifeAutoCompleteProps {
  value?: number;
  name?: string;
  label?: string;
  onChange?: (e: AutoCompleteTargetNumber) => void;
  onBlur?: (e: AutoCompleteTargetNumber) => void;
  helperText?: string;
  error?: boolean;
  id?: string;
  sx?: SxProps<Theme>;
  pasifDahil?: boolean;
}
const TarifeAutoComplete = (
  props: ITarifeAutoCompleteProps
): JSX.Element => {
  const [option, setOption] = useState(new Array<HbsUcretTarifetanim>());
  const [value, setValue] = useState<HbsUcretTarifetanim>(new HbsUcretTarifetanim());
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {

    HbsUcretTarifetanimService
      .find({
        sorts: [
          {
            fieldName: 'aciklama'
          }
        ]
      })
      .then((res) => {
        if (res.responseCode != 200) {
          return;
        }
        setOption(res.data);

      });

  }, []);

  useEffect(() => {
    var val = option?.find((f) => f.id == props.value);
    if (!val && option.length == 1)
      setValue(option[0]);
    setValue(val);
  }, [option?.length, props.value]);

  useEffect(() => {
    setErrorMessage(props.helperText);
  }, [props.helperText]);

  return (
    <Autocomplete
      fullWidth
      freeSolo={false}
      multiple={false}
      sx={props.sx}
      id={props.id}
      value={value?.id > 0 ? value : null}
      options={option}
      filterOptions={(option, state) => {
        return option.filter(f => helper.UpperCaseAsc(f.aciklama).indexOf(helper.UpperCaseAsc(state.inputValue)) > -1)
      }}
      getOptionLabel={(option) => {
        if (!option.aciklama)
          return "";
        return option.aciklama
      }
      }
      renderOption={(props, option) => {
        if (!option?.id)
          return "";
        return (
          <li {...props} key={option.id}>
            {option.aciklama}
          </li>
        );
      }}
      onBlur={(e) => {
        if (props.onBlur)
          props.onBlur({ ...e, target: { value: value?.id, name: props.name } });
      }}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      onChange={(e, v, r, d) => {
        setValue(v)
        if (props.onChange)
          props.onChange({ target: { value: v?.id, name: props.name } });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          error={props.error || Boolean(errorMessage)}
          helperText={errorMessage}
        />
      )}

    />
  );
};
export default TarifeAutoComplete;
